export default "__VITE_ASSET__DIiLYY7b__"